document.body.className = document.body.className.replace('no-js', 'js');

window.htmx = require('htmx.org');

import './site-header';
import './video-modal';
import './testimonial-carousel';
import './cta-donate';
import './filter-form';
import './image-gallery';
import './people-card';
import './accordion';
import './stats';
import './card-carousel';
import './copy-link';
